module.exports = __webpack_public_path__ + "9a0d54f8b8846af7f31b8c942cf36d69.svg";